import { userTypes } from "@/types";

export const state: userTypes = {
  user: {}
};
